module.exports = __webpack_public_path__ + "img/avatar.68261fa5.png";